// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2uxWC","buttons":"SendReceipts_buttons__2FlUZ","email":"SendReceipts_email__2C-eV","bookApptTitle":"SendReceipts_bookApptTitle__2JT8C"};